<template>
  <div class="wrapper">
    <div class="wrapper-header">
      <TabsWidget activeTab="voting_topup" @selected="switchTab"></TabsWidget>
      <div class="tab-options"></div>
    </div>
    <div class="wrapper-body">
      <!-- Voting session-->
      <div class="left-panel">
        <div class="left-panel-header">
          <div class="left-panel-header-title">
            <span>VOTING SESSIONS</span>
          </div>
          <div class="left-panel-header-option">

          </div>
        </div>
        <div class="left-panel-body">
          <div class="voting-session-item" v-for="(item, index) in voting_sessions" :key="index"
            @click="selectVotingSession(item)" :class="{
              active:
                selected_voting_session &&
                selected_voting_session.id == item.id,
            }">
            <div v-if="item.cover_image" class="voting-session-item-cover-image-panel">
              <img :src="$store.state.ASSETS_BASE_URL +
                '/assets/uploaded/' +
                item.cover_image
                " />
            </div>
            <div class="voting-session-item-top-panel">
              <div class="voting-session-item-image">
                <img :src="$store.state.ASSETS_BASE_URL +
                  '/assets/uploaded/' +
                  item.logo
                  " />
              </div>
              <div class="voting-session-item-title">
                <span>{{ item.title }}</span>
              </div>
              <div class="voting-session-item-option">
                <b-dropdown aria-role="list" class="is-pulled-right" position="is-bottom-left">
                  <template #trigger>
                    <b-icon icon="dots-vertical"></b-icon>
                  </template>

                  <b-dropdown-item v-clipboard:copy="`${$store.state.SITE_BASE_URL}voting/${item.slug}`
                    " v-clipboard:success="onCopy" v-clipboard:error="onCopyError" aria-role="listitem">Get
                    Link</b-dropdown-item>
                </b-dropdown>
              </div>
            </div>
            <div class="voting-session-item-bottom-panel">
              <div class="voting-session-item-bottom-left">
                <div class="voting-session-item-startdate">
                  <b-icon icon="calendar"></b-icon>
                  <span>Start Date:
                    {{
                      moment(item.start_time).format("MMMM Do YYYY, h:mm A")
                    }}</span>
                </div>
                <div class="voting-session-item-enddate">
                  <b-icon icon="calendar"></b-icon>
                  <span>End Date:
                    {{
                      moment(item.end_time).format("MMMM Do YYYY, h:mm A")
                    }}</span>
                </div>
              </div>
              <div class="voting-session-item-bottom-left">
                <b-tag v-if="item.status == 'public'" type="is-success">Public</b-tag>
                <b-tag v-if="item.status == 'unlisted'" type="is-danger">Unlisted</b-tag>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Voting Participants -->
      <div class="rigth-panel selected_session" v-if="selected_voting_session">
        <div class="rigth-panel-hader">
          <div class="rigth-panel-header-title">
            <span>PARTICIPANTS</span>
          </div>
          <div class="rigth-panel-header-option">
            <b-input @input="onSearchParticipants" type="search" placeholder="Search Participants"
              icon="magnify"></b-input>
            <b-button type="is-info" outlined @click="showAddedVotesHistoryModal()">Added Votes History</b-button>
            <p @click="resetVotingSession()">Close</p>
          </div>
        </div>
        <div class="rigth-panel-body">
          <div v-for="(category, cat_index) in categories" :key="cat_index" class="voting-category-widget">
            <div class="voting-category-header">
              {{ category.name }}
            </div>
            <div class="voting-category-body" v-if="category.participants.length > 0">
              <div class="voting-participant-item" v-for="(item, index) in category.participants" :key="index">
                <div class="voting-participant-item-header">
                  <div class="voting-participant-item-image">
                    <img v-if="item.image" :src="$store.state.ASSETS_BASE_URL +
                      '/assets/uploaded/' +
                      item.image
                      " />

                    <img v-else :src="$store.state.ASSETS_BASE_URL +
                      '/assets/uploaded/' +
                      selected_voting_session.logo
                      " />
                  </div>
                </div>
                <div class="voting-participant-item-body">
                  <div class="voting-participant-item-title">
                    {{ item.name }}
                  </div>
                  <div class="voting-participant-item-option">
                    <b-dropdown aria-role="list" class="is-pulled-right" position="is-bottom-left">
                      <template #trigger>
                        <b-icon icon="dots-vertical"></b-icon>
                      </template>
                      <b-dropdown-item @click="topVotesOnParticipant(item)" aria-role="listitem">Topup
                        Votes</b-dropdown-item>

                      <b-dropdown-item @click="addVotesManuallyModal(item)" aria-role="listitem">Add Votes
                        Manually</b-dropdown-item>

                    </b-dropdown>
                  </div>
                </div>
                <div class="voting-participant-item-footer">
                  <div class="voting-participant-item-footer-left">
                    <div class="voting-participant-item-votes">
                      <span>{{ item.votes ? item.votes : 0 }} Votes</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-else class="vvoting-category-body">
              <widgetNotfound title="No Participants" subtitle="No participants found in this category">
              </widgetNotfound>
            </div>
          </div>
        </div>
      </div>
      <div v-else class="rigth-panel">
        <widgetNotfound class="no_category_selected" v-if="!selected_voting_session" title="No Participants"
          subtitle="No participants found, Select a voting session to start to topup votes on any participants">
        </widgetNotfound>
      </div>
    </div>

    <!-- Topvotes modal -->
    <PayVoteModal v-if="show_topup_votes_modal" :participant="selected_participant" :session="selected_voting_session"
      @onClose="onTopupVotesAdded" @onCancel="show_topup_votes_modal = false">
    </PayVoteModal>

    <!-- Add Votes Manually modal -->
    <AddVotesManuallyModal v-if="show_add_votes_manually_modal" :participant="selected_participant"
      :session="selected_voting_session" @onClose="onVotesAddedManually"
      @onCancel="show_add_votes_manually_modal = false">
    </AddVotesManuallyModal>

    <!-- Added Votes History modal -->
    <AddedVotesHistoryModal v-if="show_added_votes_history_modal" :session="selected_voting_session"
      @onClose="show_added_votes_history_modal = false">
    </AddedVotesHistoryModal>

  </div>
</template>

<script>
import PayVoteModal from "./modals/payVoteModal.vue";
import AddVotesManuallyModal from "./modals/addVotesManuallyModal.vue";
import AddedVotesHistoryModal from "./modals/addedVotesHistoryModal.vue";
import TabsWidget from "./components/TabsWidget.vue";
export default {
  components: {
    PayVoteModal,
    AddVotesManuallyModal,
    AddedVotesHistoryModal,
    TabsWidget,
  },
  sockets: {},
  data: () => ({
    selected_voting_session: null,
    loading_voting_session: false,
    voting_sessions: [],
    show_winners: false,
    categories: [],
    original_categories: [], // Store original data for search
    search_query: "",
    selected_participant: null,
    show_topup_votes_modal: false,
    show_add_votes_manually_modal: false,
    show_added_votes_history_modal: false,
  }),
  watch: {},
  mounted() {
    let vm = this;
    vm.getMyVotingSessions();
  },
  methods: {
    resetVotingSession() {
      let vm = this;
      vm.selected_voting_session = null;
    },
    onTopupVotesAdded() {
      let vm = this;
      vm.show_topup_votes_modal = false;
      vm.showWinners(false);
    },
    topVotesOnParticipant(item) {
      let vm = this;
      vm.selected_participant = item;
      vm.show_topup_votes_modal = true;
    },
    addVotesManuallyModal(item) {
      let vm = this;
      vm.selected_participant = item;
      vm.show_add_votes_manually_modal = true;
    },
    onVotesAddedManually() {
      let vm = this;
      vm.show_add_votes_manually_modal = false;
      vm.showWinners(false); // Refresh the participants list
    },
    showAddedVotesHistoryModal() {
      let vm = this;
      if (!vm.selected_voting_session) {
        vm.$notify({
          group: "status",
          type: "warn",
          title: "No Session Selected",
          text: "Please select a voting session first to view votes history",
        });
        return;
      }
      vm.show_added_votes_history_modal = true;
    },
    showWinners(status) {
      let vm = this;
      vm.show_winners = status;
      vm.loading_voting_participants = true;
      vm.$store
        .dispatch("VOTING_GET_MY_VOTING_PARTICIPANTS_REPORT", {
          session_id: vm.selected_voting_session.id,
          showWinner: status,
        })
        .then((res) => {
          vm.loading_voting_participants = false;
          vm.categories = res.data.return;
          vm.original_categories = JSON.parse(JSON.stringify(res.data.return)); // Deep clone
          vm.search_query = ""; // Reset search
        })
        .catch((err) => {
          vm.loading_voting_participants = false;
        });
    },
    selectVotingSession(item) {
      let vm = this;
      vm.selected_voting_session = item;
      vm.loading_voting_participants = true;
      vm.$store
        .dispatch("VOTING_GET_MY_VOTING_PARTICIPANTS_REPORT", {
          session_id: item.id,
          showWinner: false,
        })
        .then((res) => {
          vm.loading_voting_participants = false;
          vm.categories = res.data.return;
          vm.original_categories = JSON.parse(JSON.stringify(res.data.return)); // Deep clone
          vm.search_query = ""; // Reset search
        })
        .catch((err) => {
          vm.loading_voting_participants = false;
        });
    },
    getMyVotingSessions() {
      let vm = this;
      vm.loading_voting_session = true;
      vm.$store
        .dispatch("VOTING_GET_MY_VOTING_SESSIONS")
        .then((response) => {
          vm.loading_voting_session = false;
          vm.voting_sessions = response.data.return;
        })
        .catch(({ response }) => {
          vm.loading_voting_session = false;
        });
    },
    onCopy() {
      let vm = this;
      vm.$buefy.toast.open({
        message: "Link copied to clipboard",
        type: "is-success",
      });
    },
    onCopyError() {
      let vm = this;
      vm.$buefy.toast.open({
        message: "Failed to copy",
        type: "is-danger",
      });
    },
    switchTab(type) {
      let vm = this;
      vm.$emit("tab", type);
    },
    onSearchParticipants(query) {
      let vm = this;
      vm.search_query = query;

      // If search is empty, restore original data
      if (!query || query.trim() === "") {
        vm.categories = JSON.parse(JSON.stringify(vm.original_categories));
        return;
      }

      // Filter participants by name
      const searchLower = query.toLowerCase().trim();

      // Create filtered categories
      vm.categories = vm.original_categories.map(category => {
        return {
          ...category,
          participants: category.participants.filter(participant =>
            participant.name.toLowerCase().includes(searchLower)
          )
        };
      }).filter(category => category.participants.length > 0); // Remove empty categories
    },
  },
};
</script>
<style lang="scss" scoped>
.wrapper {
  padding: 0px;
  display: flex;
  flex-direction: column;
  height: 100%;

  .wrapper-header {
    width: 100%;
    height: 60px;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #ddd;
    padding-left: 6px;
    overflow-x: auto;

    .tabs-widget {
      display: flex;
      align-items: flex-end;
      white-space: nowrap;
      margin-right: 20px;

      .h-spacer {
        margin-right: 20px;
      }

      .tab-item {
        cursor: pointer;
        padding: 14px 4px;
        border-bottom: 3px solid transparent;

        &.active {
          color: var(--wecodefy-secondary-color, #9fc953);
          border-bottom: 3px solid var(--wecodefy-secondary-color, #9fc953);
        }
      }
    }

    .tab-options {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0px 10px;

      .h-spacer {
        margin-right: 10px;
      }
    }
  }

  .wrapper-body {
    height: calc(100% - 60px);
    display: flex;


    .left-panel {
      height: 100%;
      width: 400px;
      display: flex;
      flex-direction: column;

      .left-panel-header {
        height: 60px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0px 10px;
        border-bottom: 1px solid #ddd;
        background: #fff;

        .left-panel-header-title {
          font-size: 14px;
          font-weight: 600;
        }

        .left-panel-header-option {
          display: flex;
          align-items: center;
          justify-content: space-between;

          .h-spacer {
            margin-right: 10px;
          }
        }
      }

      .left-panel-body {
        overflow-y: auto;
        height: calc(100% - 60px);
        display: flex;
        flex-direction: column;

        .voting-session-item {
          width: 100%;
          display: flex;
          flex-direction: column;
          border-bottom: 1px solid #ddd;
          cursor: pointer;
          margin-bottom: 10px;

          &:hover {
            background: #fff;
          }

          &.active {
            background: #fff;
          }

          .voting-session-item-cover-image-panel {
            height: 100px;
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: center;

            img {
              height: 100%;
              width: 100%;
              object-fit: cover;
            }
          }

          .voting-session-item-top-panel {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 10px;

            .voting-session-item-image {
              width: 50px;
              height: 50px;
              border-radius: 50%;
              overflow: hidden;

              img {
                width: 100%;
                height: 100%;
                object-fit: cover;
              }
            }

            .voting-session-item-title {
              font-size: 14px;
              font-weight: 600;
              color: #333;
              width: calc(100% - 60px);
              padding: 0px 10px;
            }

            .voting-session-item-option {
              display: flex;
              align-items: center;
              justify-content: center;
              width: 10px;
            }
          }

          .voting-session-item-body-panel {
            padding: 0px 10px;
          }

          .voting-session-item-bottom-panel {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 10px;

            .voting-session-item-bottom-left {
              display: flex;
              flex-direction: column;

              .voting-session-item-startdate,
              .voting-session-item-enddate {
                font-size: 12px;
                color: #333;
                margin-bottom: 5px;
                display: flex;
                align-items: center;
              }
            }

            .voting-session-item-bottom-right {
              display: flex;
              align-items: center;
              justify-content: center;
            }
          }
        }
      }
    }

    .rigth-panel {
      width: calc(100% - 400px);
      height: 100%;
      border-left: 1px solid #ddd;

      @media (max-width: 650px) {
        position: absolute;
        background: white;
        z-index: 10;
        top: 60px;
        right: -800px;
        width: 85%;
        box-shadow: -10px 10px 10px rgba(0, 0, 0, 0.089);
        transition: .5s;
      }

      &.selected_session {
        @media (max-width: 650px) {
          right: 0;
        }
      }

      .rigth-panel-hader {
        height: 60px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-bottom: 1px solid #ddd;
        padding: 0px 10px;
        background: #fff;

        .rigth-panel-header-option {
          display: flex;
          justify-content: space-between;
          align-items: center;
          gap: 10px;

          p {
            display: none;
            margin-left: 10px;
            color: red;
            font-weight: 700;
            cursor: pointer;

            @media (max-width: 650px) {
              display: flex;
            }
          }
        }
      }

      .rigth-panel-body {
        height: calc(100% - 60px);
        overflow-y: auto;
        display: flex;
        flex-direction: column;

        .voting-category-widget {
          .voting-category-header {
            height: 60px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 0px 10px;
            border-bottom: 1px solid #ddd;
            border-top: 1px solid #ddd;
            background: #fff;
          }

          .voting-category-body {
            display: grid;
            grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
            grid-gap: 20px;
            padding: 10px 10px;

            .voting-participant-item {
              width: 100%;
              display: flex;
              flex-direction: column;
              border: 1px solid #ddd;
              cursor: pointer;
              height: max-content;
              padding: 10px;
              border-radius: 10px;

              &:hover {
                background: #f5f5f5;
              }

              &.active {
                background: #f5f5f5;
              }

              .voting-participant-item-header {
                display: flex;
                align-items: center;
                justify-content: space-between;

                .voting-participant-item-image {
                  width: 100%;
                  height: 150px;
                  overflow: hidden;
                  border-radius: 10px;

                  img {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                  }
                }
              }

              .voting-participant-item-body {
                display: flex;
                justify-content: space-between;
                padding: 10px 0px;

                .voting-participant-item-title {
                  font-size: 14px;
                  font-weight: 600;
                  color: #333;
                }

                .voting-participant-item-option {
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  width: 10px;
                }
              }

              .voting-participant-item-footer {
                display: flex;
                align-items: center;
                justify-content: space-between;

                .voting-participant-item-footer-left {
                  display: flex;
                  align-items: center;
                  justify-content: center;

                  .voting-participant-item-votes {
                    font-size: 14px;
                    color: var(--wecodefy-secondary-color, #9fc953);
                  }
                }

                .voting-participant-item-footer-right {
                  display: flex;
                  align-items: center;
                  justify-content: center;
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
